module.exports = __webpack_public_path__ + "img/episode3.1b1142d0.png";